export default __webpack_public_path__ + "static/media/garlands3.4ce792ed.png";